
define('modules/application/wizard/steps/zoneStep/complexZoneStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zoneStep",
  "./complexZoneStep/zonesMenuView",
  "./complexZoneStep/zoneCollection",
  "./complexZoneStep/zoneModel",
  "./complexZoneStep/zoneDetailView",

  //Widgets
  "../../../widgets/consumptionIndicator"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneStep,
  ZonesMenuView,
  ZoneCollection,
  ZoneModel,
  ZoneDetailView,
  consumptionIndicator) {

  var Views        = _.extend({}, ZoneStep.Views);

  Views.Content    = Views.Content.extend({

    addConstructors   : function() {
      ZoneStep.Views.Content.prototype.addConstructors.apply(this);
      this.ZonesMenuView  = ZonesMenuView;
      this.ZoneDetailView = ZoneDetailView;
    },

    initialize        : function() {
      this.addConstructors();
      var that = this;

      window.BticinoS4B.eventAggregator.unbind("zone:selected",           this.zoneSelectedEventHandler);
      window.BticinoS4B.eventAggregator.bind("zone:selected",             this.zoneSelectedEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("zone:selectionRequested", this.zoneSelectionRequestedEventHandler);
      window.BticinoS4B.eventAggregator.bind("zone:selectionRequested",   this.zoneSelectionRequestedEventHandler, this);

      this.insertView(".menu",new this.ZonesMenuView({ model   :   this.model, stepEventAggregator : this.options.stepEventAggregator  }));
    },

    setSelectedZone                            : function(newModel)
    {
      var sections = newModel.get("sections") ? newModel.get("sections") : this.model.get("sections");
      this.setView(".detail",new this.ZoneDetailView({
        model               : _.extend({stepEventAggregator : this.options.stepEventAggregator}, newModel),
        sections            : sections
      })).render();
    },

    beforeRender : function() {
      //Bind on confirm button click
      this.model = this.options.model;

      //Instancing sections
      var objModel= "";
      var pageContent     = $(this.el).find(".itemView");
      var confirmSection  = $(this.el).find("footer");

      if(confirmSection.length)
        pageContent.css("height", (this.$el.height()-confirmSection.height())+"px");
      else
        pageContent.css("height", this.$el.height()+"px");

      $(this.el).find("h3 .titleBarcontent span").corner("2px");
      $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
    }
  });

  var Model        = ZoneStep.Model.extend({

    addConstructors                     : function() {
      ZoneStep.Model.prototype.addConstructors.apply(this);
      this.ZoneCollection = ZoneCollection;
      this.ZoneModel      = ZoneModel;
    },

    initialize                          : function() {
      this.addConstructors();

      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:selected",           this.mainControlUnitSelectedEventHandler);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:selected",             this.mainControlUnitSelectedEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:removed",            this.mainControlUnitRemovedEventHandler);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:removed",              this.mainControlUnitRemovedEventHandler, this);

      this.get("stepEventAggregator").unbind('collection:validated',   this.collectionValidatedEventHandler);
      this.get("stepEventAggregator").bind('collection:validated',     this.collectionValidatedEventHandler, this);

      this.get("stepEventAggregator").unbind('collection:unvalidated', this.collectionUnvalidatedEventHandler);
      this.get("stepEventAggregator").bind('collection:unvalidated',   this.collectionUnvalidatedEventHandler, this);

      //Bind on materials overview model delivery request
      window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",               this.deliverModel);
      window.BticinoS4B.eventAggregator.bind("modelDeliver:request",                 this.deliverModel, this);

      window.BticinoS4B.eventAggregator.unbind("load:Project",                       this.loadProject);
      window.BticinoS4B.eventAggregator.bind("load:Project",                         this.loadProject, this);

      //Bind on current delivery request
      window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested",           this.deliverCurrent);
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",             this.deliverCurrent, this);

      this.instanceCollection();
    },

    instanceCollection                  : function() {
      this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});
      this.addZone(null);
      this.get("stepEventAggregator").trigger("collection:initialized");
      this.instanceAdditionalSections();
    },

    instanceAdditionalSections          : function() {
      var additionalZones  = this.get("additionalZones"), additionalZonesLength = additionalZones.length;
      var zoneToAdd, zoneNumber;
      this.additionalZones = [];

      for (var i=0; i<additionalZonesLength; i++)
      {
        if (additionalZones[i].role==="zone")
        {
          zoneNumber = this.getZoneNumber(additionalZones[i].name);

          zoneToAdd  = new this.ZoneModel({
            name                : additionalZones[i].name,
            number              : zoneNumber,
            sections            : additionalZones[i].sections,
            isAdditional        : true,
            validable           : additionalZones[i].validable,
            valid               : true,
            stepEventAggregator : this.get("stepEventAggregator"),
            zoneEventAggregator : _.extend({}, Backbone.Events)
          });
          this.additionalZones.push(zoneToAdd);
        }
        else if (additionalZones[i].role==="separator")
        {
          this.additionalZones.push({name : additionalZones[i].name, role : "separator"});
        }
      }
    },

    addZone                             : function(newModel) {
      var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;
      if (this.collection.length<maxZoneNumber) {
        BticinoS4B.Instances.Models.ApplicationModel.set("zoneInserted", true);
        if (newModel===null)
          this.collection.add(new this.ZoneModel({
            number              : this.collection.length>0 ? this.collection.models[this.collection.length-1].get("number")+1: this.collection.length+1,
            name                : "{defaultName} "+(this.collection.length+1),
            stepEventAggregator : this.get("stepEventAggregator"),
            zoneEventAggregator : _.extend({}, Backbone.Events)
          }));
        else
          this.collection.add(_.extend(newModel, {zoneEventAggregator : _.extend({}, Backbone.Events)}));

        this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        BticinoS4B.Instances.Models.ApplicationModel.set("zoneLength", this.collection.length);
      }
      else {
        alert($.i18n._("IDS_W1_9090"));
      }
    },

    loadZone                            : function(newModel) {
      var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;
      if (this.collection.length<maxZoneNumber) {
        var zoneToLoad = new this.ZoneModel(_.extend({
          stepEventAggregator : this.get("stepEventAggregator"),
          zoneEventAggregator : _.extend({}, Backbone.Events)
        }, newModel));

        this.collection.add(zoneToLoad);
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
      }
    },

    loadAdditionalZone                  : function(newModel) {
      var i=0;

      for (i=0; i<this.additionalZones.length; i++)
      {
        if (this.additionalZones[i].attributes && this.additionalZones[i].get("name")===newModel.name)
        {
          zoneToUpdate = i;
          break;
        }
      }

      var zoneToLoad = new this.ZoneModel(_.extend({
        stepEventAggregator : this.get("stepEventAggregator"),
        zoneEventAggregator : _.extend({}, Backbone.Events)
      }, newModel));

      zoneToLoad.set("sections", this.additionalZones[zoneToUpdate].get("sections"));

      new this.ZoneDetailView({
        model               : _.extend({stepEventAggregator : this.get("stepEventAggregator")}, zoneToLoad),
        sections            : zoneToLoad.get("sections")
      });

      this.additionalZones[zoneToUpdate] = zoneToLoad;
      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
    },

    removeZone                          : function(zoneToRemove) {
      BticinoS4B.Instances.Models.ApplicationModel.set("zoneInserted", true);
      ZoneStep.Model.prototype.removeZone.apply(this, [zoneToRemove]);
      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
      BticinoS4B.Instances.Models.ApplicationModel.set("zoneLength", this.collection.length);
    },

    deliverCurrent                      : function() {
      var collection = this.collection, collectionLength = collection.length;
      var i=0;

      for (i=0; i<collectionLength; i++)
        if (collection.models[i].deliverCurrent)
          collection.models[i].deliverCurrent();
    }
  });

  //Creating final complexZoneStep class
  var complexZoneStep      = _.extend({}, ZoneStep, {
    objClass      : "complexZones",
    Views         : Views,
    Model         : Model
  });

  // Required, return the module for AMD compliance
  return complexZoneStep;

});